import { Profile } from '@/types/User';
import Request from './request';
import { CPAAssociateResponse, CPAPollingResponse, CPARegisterResponse } from '@/types/CPA';
import { Bookmark, PlaylistResponse } from '@/types/Bookmarks';


export default class PeachAPI {
  private noAuthRequest = new Request()
  private authRequest = new Request()

  setAuthToken(token: string) {
    this.authRequest.updateHeaders({ 'Authorization': `Bearer ${token}`, 'Token-Type': 'cpa' })
  }

  clearAuth() {
    this.authRequest.updateHeaders({})
  }

  async cpaRegister(): Promise<CPARegisterResponse> {

    let payload = {
      "software_id": "com.tg4.smartTV",
      "software_version": "1.0.0",
      "client_name": "TG4 SmartTV"
    }

    return await this.noAuthRequest.post<CPARegisterResponse>('https://sso.tg4.ie/register', payload)
  }

  async cpaAssociate(response: CPARegisterResponse): Promise<CPAAssociateResponse> {
    let payload = {
      "client_id": response.client_id,
      "client_secret": response.client_secret,
      "domain": "tg4.ie"
    }
    return await this.noAuthRequest.post<CPAAssociateResponse>(`https://sso.tg4.ie/associate`, payload)
  }

  async cpaPole(registerResponse: CPARegisterResponse, associateResponse: CPAAssociateResponse): Promise<CPAPollingResponse> {
    let payload = {
      "client_id": registerResponse.client_id,
      "domain": "tg4.ie",
      "device_code": associateResponse.device_code,
      "client_secret": registerResponse.client_secret,
      "grant_type": "http://tech.ebu.ch/cpa/1.0/device_code"
    }
    
    return await this.noAuthRequest.post<CPAPollingResponse>('https://sso.tg4.ie/token', payload)
  }

  async getUser(): Promise<Profile> {
    return await this.authRequest.get<Profile>('https://sso.tg4.ie/api/v2/session/user/profile')
  }

  async logout(): Promise<void> {
    return await this.authRequest.delete('https://sso.tg4.ie/api/v2/session/logout')
  }


  async getBookmarks(): Promise<PlaylistResponse> {
    return await this.authRequest.get<PlaylistResponse>('https://user.tg4.ie/api/playlist/v3/watch_later')
  }


  async addBookmark(videoId: string): Promise<Bookmark> {
    const payload = {
      itemId: videoId
    }
    return await this.authRequest.post<Bookmark>('https://user.tg4.ie/api/playlist/v3/watch_later/bookmarks', payload)
  }


  async removeBookmark(itemId: string): Promise<any> {
    return await this.authRequest.delete(`https://user.tg4.ie/api/playlist/v3/watch_later/bookmarks/${itemId}`)
  }

  async recordHistoryPosition(videoId: string, position: number): Promise<void> {
    return await this.authRequest.post(`https://user.tg4.ie/api/history/v2`, {
      "item_id": videoId,
      "last_playback_position": position
    })
  }
}